// Entry point for uDra Theme
import '../styles/main.css';
import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.data('contactForm', () => ({
    formData: {
        name: '',
        email: '',
        message: '',
        website: '', // Honeypot field
        _wpnonce: typeof udraTheme !== 'undefined' ? udraTheme.nonce : ''
    },
    status: 'idle', // idle, submitting, success, error
    feedback: '',

    reset() {
        this.formData = {
            name: '',
            email: '',
            message: '',
            website: '',
            _wpnonce: typeof udraTheme !== 'undefined' ? udraTheme.nonce : ''
        };
        this.status = 'idle';
        this.feedback = '';
    },

    async submit() {
        // Honeypot check - if filled, silently pretend success
        if (this.formData.website) {
            this.status = 'success';
            this.feedback = 'Nachricht gesendet. Ich melde mich in Kürze.';
            return;
        }

        this.status = 'submitting';
        this.feedback = '';

        try {
            const restUrl = typeof udraTheme !== 'undefined' ? udraTheme.restUrl : '/wp-json/';
            const nonce = typeof udraTheme !== 'undefined' ? udraTheme.nonce : '';

            const response = await fetch(`${restUrl}udra/v1/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': nonce
                },
                body: JSON.stringify({
                    name: this.formData.name,
                    email: this.formData.email,
                    message: this.formData.message
                })
            });

            const result = await response.json();

            if (response.ok) {
                this.status = 'success';
                this.feedback = result.message || 'Nachricht gesendet. Ich melde mich in Kürze.';
                // Reset form after success
                setTimeout(() => {
                    this.formData.name = '';
                    this.formData.email = '';
                    this.formData.message = '';
                }, 2000);
            } else {
                this.status = 'error';
                this.feedback = result.message || 'Ein Fehler ist aufgetreten.';
            }
        } catch (error) {
            this.status = 'error';
            this.feedback = 'Netzwerkfehler. Bitte versuche es später erneut.';
        }
    }
}));

Alpine.start();
